
<basin-main
  menuThemeColor="blue"
  [homeLink]="true"
  (homeLinkClick)="openHomeLink()"
  (stantecLensClick)="openHomeLink()"
  [homeLinkClickable]="true"
  [stantecLensClickable]="true"
  currentPageTitle="DebrisFlow Predictor"
  [displayHeaderIcon]="false"
  [showProfile]="true"
  [userProfile]="userProfile$ | async"
  [ellipsesMenu]="false"
  [navItems]="navItems"
  [profileMenuItems]="profileMenuItems"
  [footerMenuItems]="footerMenuItems"
>
  <div content class="basin-height-100">
    <app-loading-indicator *ngIf="loading$ | async"></app-loading-indicator>
    <router-outlet></router-outlet>
  </div>
  
</basin-main>


